import { Div, Collection, Ref, Button } from "@tblabs/truffle";
import { Tab } from "../../../Models/Product/Tab";


export class Tabs extends Div
{
    constructor(collection: Collection<Tab>, selectedTab: Ref<string>)
    {
        super("product-info__tabs-scroll");

        const buttons = collection.Items
            .filter(x => x.IsVisible.value)
            .map(entry =>
                new Button(entry.Label.value).Class("tabs__trigger product-info__tab-trigger")
                    .OnClick(btn => selectedTab.value = entry.Label.value)
                    .When(selectedTab, v => v === entry.Label.value, btn => btn.Class("active"), btn => btn.RemoveClass("active"))
            )

        this.Append(
            new Div("tabs__list product-info__tabs-list").Append(
                ...buttons
            )
        );
    }
}
